import { render } from "./Upcoming.vue?vue&type=template&id=115e0945&scoped=true&ts=true"
import script from "./Upcoming.vue?vue&type=script&lang=ts"
export * from "./Upcoming.vue?vue&type=script&lang=ts"

import "./Upcoming.vue?vue&type=style&index=0&id=115e0945&lang=scss&scoped=true"

import exportComponent from "/workspace/hound-platform/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-115e0945"]])

export default __exports__